import NAME from "./constants";

export const getAudioPlayerIsOpen = store => store[NAME].open;
export const getAudioName = store => store[NAME].audioName;
export const getTitle = store => store[NAME].title;
export const getAssistantVoiceType = store => store[NAME].assistantVoiceType;